import { render, staticRenderFns } from "./VsToast.vue?vue&type=template&id=8a34655a&lang=pug&"
import script from "./VsToast.vue?vue&type=script&lang=js&"
export * from "./VsToast.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8a34655a')) {
      api.createRecord('8a34655a', component.options)
    } else {
      api.reload('8a34655a', component.options)
    }
    module.hot.accept("./VsToast.vue?vue&type=template&id=8a34655a&lang=pug&", function () {
      api.rerender('8a34655a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "node_modules/viralstyle-ui/src/VsToast.vue"
export default component.exports